import styled from 'styled-components'

export const HeaderBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(98, 147, 97, 0.15);
  padding: 15px;
  font-family: "SF Pro Display" , sans-serif;
  font-weight: 600;
`
